<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">담당자</h3>
		<div class="white-box clearfix">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				관리 담당자
			</p>
			<select class="w200 form-control-sm round m-b-0 m-r-5 pull-left" v-model="lecData.inCharge">
				<option value="">=== 관리 담당자를 선택하세요 ===</option>
				<option v-for="(admin, index) in admins" :key="'admin-list-'+hash(admin)" :index="index" :value="admin.mberId">{{admin.mberName}}</option>
			</select>
			<p class="w160 bg-darkgray form-control-sm m-b-0 pull-right text-white round" style="box-sizing: border-box;" v-if="adminPhone">
				문의: {{ adminPhone }}
			</p>
		</div>
		<!-- <div class="white-box clearfix">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				강사
			</p>
			<div class="input-group m-b-30 full-width">
				<span class="input-group-addon">
					<input id="check1" class="checkbox3-sm" type="radio" name="instAllotType" value="강사없음" v-model="lecData.instAllotType">
					<label for="check1" class="v-mid full-width">강사없음</label>
				</span>
				<span class="input-group-addon p-l-5">
					<input id="check2" class="checkbox3-sm" type="radio" name="instAllotType" value="강사지정" v-model="lecData.instAllotType">
					<label for="check2" class="v-mid full-width">강사지정</label>
				</span>
				<span class="input-group-addon p-l-5">
					<input id="check3" class="checkbox3-sm" type="radio" name="instAllotType" value="신청 후 배정" v-model="lecData.instAllotType">
					<label for="check3" class="v-mid full-width">신청 후 배정</label>
				</span>
			</div>
			<template v-if="lecData.instAllotType=='강사지정'">
				<div class="input-group full-width m-b-10">
					<span class="input-group-addon w180 left-round">
						<select class="form-control round full-width m-b-0">
							<option>강사</option>
						</select>
					</span>
					<span class="input-group-addon p-l-5 v-mid">
						<div class="search-box full-width">
							<input id="search" class="form-control round full-width m-b-0" type="text" autocomplete="off" v-model="keyword" @focusin="isFocus=true">
							<label for="search">검색</label>
							<ul class="search-list" v-if="filteredTeachers.length>0" :style="isFocus?'display:block':''">
								<li v-for="(teacher, index) in filteredTeachers" :key="'teacher-list-'+hash(teacher)+index" :index="index">
									<a @click="appendTeacher(teacher)">{{teacher.mberName}}, {{teacher.mobileNum}}, {{teacher.email}}</a>
								</li>
							</ul>
							<ul class="search-list" v-if="filteredTeachers.length==0">
								<li>
									<a @click="isFocus=false">==== 검색된 강사가 없습니다 ====</a>
								</li>
							</ul>
						</div>
					</span>
				</div>
				<div class="input-group full-width m-b-5" v-for="(teacher, index) in lecData.eduList" :key="'selected-teacher-list-'+hash(teacher)+index" :index="index">
					<span class="input-group-addon w180 left-round">
						<div class="round full-width on-border">
							{{(teacher.instInfo&&teacher.instInfo.localKorInst)?teacher.instInfo.localKorInst:"강사"}}
						</div>
					</span>
					<span class="input-group-addon p-l-5 v-mid">
						<div class="round full-width on-border">
							{{teacher.mberName}}, {{teacher.mobileNum}}, {{teacher.email}}
						</div>
					</span>
					<span class="input-group-addon w60 p-l-5 v-mid">
						<button class="btn-sm btn-red round full-width" @click="lecData.eduList.splice(lecData.eduList.indexOf(teacher), 1)">삭제</button>
					</span>
				</div>
			</template>
		</div> -->

		<!-- button wrapper -->
		<!-- <button class="btn btn-red round m-t-30 pull-left" type="button" @click="setInitValue">초기값으로 설정</button> -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep">저장하고 넘어가기</button>
		<button class="btn round m-t-30 m-r-5 pull-right" type="button" @click="skipStep">건너뛰기</button>
	</div>
</template>

<script>
import axios from 'axios'
import server from '../../statics/server.js'

export default {
	name: "SubviewClassRegisterStep_4",
	data: function() {
		return {
			lecData: {
				inCharge: this.classData.inCharge,
				eduList: JSON.parse(JSON.stringify(this.classData.eduList)),
				instAllotType: this.classData.instAllotType,
			},
			keyword: "",
			isFocus: false
		}
	},
	props: {
		classData: Object,
		admins: Array,
		teachers: Array,
		default: Object
	},
	methods: {
		appendTeacher: function(teacher) {
			axios.post(server.addr()+server.api.MBER+"/"+teacher.mberId).then( (response) => {
				if(response.status==200) {
					if(response.data) {
						this.$set(teacher, "instInfo", response.data.instInfo);
						this.lecData.eduList.push(teacher);
						this.isFocus = false;
					} else {
						// eslint-disable-next-line
						// console.log("통신오류 (data not exists)", response);
					}
				} else {
					// eslint-disable-next-line
					// console.log("통신오류 (status code not 200)");
				}
			}).catch( (error) => {
				error;
				// eslint-disable-next-line
				// console.log("통신오류 (catched axios exception)");
			});
		},
		setInitValue: function() {
			this.lecData.inCharge = this.default.inCharge;
			this.lecData.eduList = JSON.parse(JSON.stringify(this.default.eduTemplList));
			this.lecData.instAllotType = this.default.instAllotType;
		},
		skipStep: function() {
			this.$emit("skipStep", {});
		},
		nextStep: function() {
			if(!this.lecData.inCharge) {
				this.$emit("alert", "관리 담당자를 선택하세요.");
				return;
			}
			// if(!this.lecData.instAllotType) {
			// 	this.$emit("alert", "강사 배정 여부를 선택하세요.");
			// 	return;
			// }
			// if(this.lecData.instAllotType=="강사지정" && this.lecData.eduList.length==0) {
			// 	this.$emit("alert", "강사를 배정하세요.");
			// 	return;
			// }
			this.$emit("nextStep", this.lecData);
		}
	},
	computed: {
		adminPhone: function() {
			if(!this.lecData.inCharge) return "";
			if(typeof this.lecData.inCharge=="string")
				return this.admins.find((admin) => admin.mberId == this.lecData.inCharge).mobileNum
			else
				return this.admins.find((admin) => admin.mberId == this.lecData.inCharge.mberId).mobileNum
		},
		filteredTeachers: function() {
			return this.teachers.filter(t=>((t.mberName&&t.mberName.indexOf(this.keyword)!==-1)||(t.mobileNum&&t.mobileNum.indexOf(this.keyword)!==-1)||(t.phoneNum&&t.phoneNum.indexOf(this.keyword)!==-1)));
		}
	}
}
</script>

<style scoped>
.search-box .search-list { z-index: 1; }
</style>